<template>
  <v-app light id="app-wrapper">
    <template>
      <template v-if="loadingOverlay">
        <v-fade-transition>
          <div class="loading-overlay">
            <v-row class="fill-height" justify="center" align="center">
              <v-col cols="4" class="text-center">
                <img style="width: 100px; height: auto; opacity: 0.4;" src="/img/hubble-h-logo-pulse.svg" />
              </v-col>
            </v-row>
          </div>
        </v-fade-transition>
      </template>

      <v-snackbar v-model="snackbar" top multi-line :timeout="notification.timeOut" :color="notification.color">
        {{ notification.text }}
        <template v-slot:action>
          <template v-if="notification.showButton">
            <v-btn small outlined text @click="() => { notification.callback(); snackbar = false;}">
              {{ notification.buttonText }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon @click="snackbar = false">
              <v-icon>close</v-icon>
            </v-btn>
          </template>
        </template>
      </v-snackbar>

      <v-main>
        <router-view/>
      </v-main>

    </template>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        notification: {
          color: '',
          text: '',
          buttonText: '',
          showButton: false,
          timeOut: -1,
          callback: () => {},
        },
        snackbar: false,
        miniMenu: false,
        menuOpenState: false,
        pages: [
          {
            title: this.$t('start.title'),
            icon: 'home',
            link: 'home',
            roles: [],
            primary: true,
          },
        ],
      }
    },
    methods: {
      getPageLink(page) {
        const link = {
          name: page.link,
        }

        if ('params' in page) {
          link.params = page.params();
        }
        return link;
      },
      logout() {
        this.$store.dispatch('logout');

        this.$store.commit('setLoadingOverlay', true);
        this.menuOpenState = false;
        this.$router.push({name: 'login'});
        // this logout for remote (if not used e.g. local logout used then service has 'rememberme'-functionality)
        /*this.$Amplify.Auth.signOut().then(() => {
          // this is client side only logout
          this.$clearUserInfo();
          this.$store.commit('setLoadingOverlay', true);
          this.$store.commit('setLoggedIn', false);
          this.$router.push({name: 'login'});
        })*/
      },
      goToLink(name) {
        this.$router.push({name: name});
      },
      toggleMiniMenu() {
        if (this.$vuetify.breakpoint.lgAndUp) {
          this.miniMenu = !this.miniMenu;
        } else {
          this.$store.commit('toggleMainMenuState');
        }
      },
      closeMenuIfOnSamePage(page) {
        if (this.$vuetify.breakpoint.mdAndDown && this.$route.name === page.link) {
          this.menuOpenState = false;
        }
      },
    },
    watch: {
      loadingOverlay(to) {
        if (to) {
          setTimeout(() => {
            this.$store.commit('setLoadingOverlay', false);
          }, 2000);
        }
      },
      notificationObject(to) {
        this.notification.color = to.color;
        this.notification.text = to.message;
        this.snackbar = true;
        this.notification.buttonText = to.buttonText;
        this.notification.showButton = to.showButton;
        this.notification.timeOut = to.timeOut;
        this.notification.callback = to.callback;
      },
      menuOpenComputed(to) {
        this.menuOpenState = to;
      },
      menuOpenState(to) {
        if (to !== this.$store.state.mainMenuOpen) {
          this.$store.commit('toggleMainMenuState');
        }
      },
      $route(to, from) {
        if (from && from.name) this.$store.commit('setPreviousRouteName', from.name);
      },
      currentRouteName(val) {
        if (!this.isLoggedIn && val !== 'login') {
          //this.$router.push({name: 'login'});
        }
      },
      isLoggedIn(val) {
        if (!val && this.$route.name !== 'login') {
          //this.$router.push({name: 'login'});
        }
      }
    },
    computed: {
      showApplication() {
        return this.isLoggedIn;
      },
      isLoggedIn() {
        return this.$store.state.uid != null;
      },
      loadingOverlay() {
        return this.$store.state.loadingOverlay;
      },
      shouldMenuBeAvailable() {
        return this.isLoggedIn;
      },
      notificationObject() {
        return this.$store.state.notificationObject;
      },
      menuOpenComputed() {
        let menuState = true;
        if (this.$vuetify.breakpoint.mdAndDown) {
          menuState = this.$store.state.mainMenuOpen;
        }
        return menuState;
      },
      filteredSecondaryPages() {
        let pages = [];
        this.pages.forEach(page => {
          if (!page.primary) {
            pages.push(page);
          }
        })
        return pages;
      },
      filteredPrimaryPages() {
        let pages = [];
        this.pages.forEach(page => {
          if (page.primary) {
            pages.push(page);
          }
        })
        return pages;
      },
      currentRouteName() {
        return this.$route.name;
      }
    },
    created() {
    },
    mounted() {
      if (this.$vuetify.breakpoint.lgAndUp) this.menuOpenState = true;
    },
  }
</script>

<style lang="scss">
@import "../sass/commonstyles.scss";

.v-application--wrap {
  min-height: auto !important;
  padding-top: 10px;
  padding-bottom: 25px;
}
</style>
